import { adminFetch } from "./_client";
import type { AuditEntry } from "./types";

export function fetchEntityAuditHistory(token: string, entityType: string, entityId: string | number, limit = 30) {
  return adminFetch<{ entries: AuditEntry[]; entity_type: string; entity_id: string }>(
    `/admin/audit/by-entity/${encodeURIComponent(entityType)}/${encodeURIComponent(String(entityId))}?limit=${limit}`,
    token,
  );
}


// Task #2181 — per-user activity feed that aggregates audit_log rows across
// entity_type=user, kyc_review (joined by user_id) and dispute (joined by
// renter_id/host_id). Used by the User 360 "Activity" tab.
export function fetchUserAuditTimeline(token: string, userId: string, limit = 100) {
  return adminFetch<{ entries: AuditEntry[]; user_id: string; partial: string[] }>(
    `/admin/audit/by-user/${encodeURIComponent(userId)}?limit=${limit}`,
    token,
  );
}
